import { render, staticRenderFns } from "./SelfMedicated.vue?vue&type=template&id=9539bfbe&scoped=true&"
import script from "./SelfMedicated.vue?vue&type=script&lang=js&"
export * from "./SelfMedicated.vue?vue&type=script&lang=js&"
import style0 from "./SelfMedicated.vue?vue&type=style&index=0&id=9539bfbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9539bfbe",
  null
  
)

export default component.exports